import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import "../style.css";
import { useNavigate } from 'react-router-dom';

function ResultMultimedia({ filters, keyword, onOpen }) {
    const [multimediaItems, setMultimediaItems] = useState([]); // Store original items
    const [filteredMultimedia, setFilteredMultimedia] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortOrder, setSortOrder] = useState(null); // New state for sort order
    const navigate = useNavigate();

    useEffect(() => {
        const fetchMultimedia = async () => {
            try {
                const response = await axios.get('https://geoid-rest.vercel.app/media');
                const publicMedia = response.data.filter(media => media.access === 'public');
                setMultimediaItems(publicMedia);
                setFilteredMultimedia(publicMedia); // Initialize filtered items
                setLoading(false); // Set loading to false after data is fetched
            } catch (error) {
                console.error('Error fetching multimedia data:', error);
                setLoading(false); // Set loading to false if an error occurs
            }
        };

        fetchMultimedia();
    }, []);

    useEffect(() => {
        let filtered = multimediaItems;

        // if (filters.country) {
        //     filtered = filtered.filter(media => media.country?.toLowerCase() === filters.country.toLowerCase());
        // }
        if (filters.state) {
            filtered = filtered.filter(media => media.state?.toLowerCase() === filters.state.toLowerCase());
        }
        if (filters.category) {

            if (filters.category.toLowerCase() !== 'archaeology'){
                filtered = filtered.filter(media => media.category?.toLowerCase() !== "archaeology");
            } else {
                filtered = filtered.filter(media => media.category?.toLowerCase() === "archaeology");
            }
        }
        // if (filters.majorLithology) {
        //     filtered = filtered.filter(media => media.majorLithology?.toLowerCase() === filters.majorLithology.toLowerCase());
        // }
        // if (filters.discipline) {
        //     filtered = filtered.filter(media => media.discipline?.toLowerCase() === filters.discipline.toLowerCase());
        // }
        // if (filters.rockType) {
        //     filtered = filtered.filter(media => media.rockType?.toLowerCase() === filters.rockType.toLowerCase());
        // }
        // if (filters.formation) {
        //     filtered = filtered.filter(media => media.formation?.toLowerCase() === filters.formation.toLowerCase());
        // }
        // if (filters.age) {
        //     filtered = filtered.filter(media => media.age?.toLowerCase() === filters.age.toLowerCase());
        // }

        if (keyword) {
            const keywordLower = keyword.toLowerCase();
            filtered = filtered.filter(media =>
                media.name.toLowerCase().includes(keywordLower) ||
                media.location.toLowerCase().includes(keywordLower) ||
                media.category.toLowerCase().includes(keywordLower)
            );
        }

        setFilteredMultimedia(filtered);
    }, [filters, keyword, multimediaItems]); // Add multimediaItems to the dependency array

    // Function to sort multimedia items
    const sortMultimedia = (items) => {
        if (!sortOrder) return items; // Return unsorted items if sortOrder is null
        return [...items].sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (sortOrder === 'asc') {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });
    };

    // Apply sorting to filtered multimedia items
    const sortedMultimedia = sortMultimedia(filteredMultimedia);

    const openMediaViewer = useCallback((mediaId) => {
        navigate(`/viewMedia/${mediaId}`);
    }, [navigate]);

    const resultCount = sortedMultimedia.length;

    const handleSortToggle = () => {
        setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    if (loading) {
        return <div className="loading-message">Loading data...</div>; // Display loading message
    }

    return (
        <div className="multimedia-result-page">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <p style={{ textAlign: 'left' }}>
                    Multimedia: {resultCount} result{resultCount !== 1 ? 's' : ''} found
                </p>
                <button className='sortBy' onClick={handleSortToggle}>
                    Sort By Alphabet {
                        sortOrder === 'asc' ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
                        </svg> : 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                        </svg>
                    }
                </button>
            </div>
            <div className="multimedia-result-grid">
                {resultCount === 0 ? (
                    <p>No multimedia found.</p>
                ) : (
                    sortedMultimedia.map((item, index) => (
                        <div className="multimedia-result-card" key={item._id} onClick={() => openMediaViewer(item._id)}>
                            {item.type === "image" ? (
                                <img src={item.imgSrc} alt={item.name} className="multimedia-result-image" />
                            ) : (
                                <video className="multimedia-result-image" src={item.imgSrc} alt={item.name} />
                            )}
                            <div style={{cursor: 'pointer'}} className="multimedia-result-overlay">
                                <span>View Media > </span>
                            </div>
                            <div className="multimedia-result-info">
                                <h3>{item.name}</h3>
                                <p>{item.location}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default ResultMultimedia;